import React, { useState } from 'react';
import { FaTimes } from 'react-icons/fa';
import { useServices } from '../../hooks/useServices';
import '../../styles/DuplicateServiceModal.css';

const DuplicateServiceModal = ({ service, onClose, onSuccess }) => {
  const { duplicateService } = useServices();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [formData, setFormData] = useState({
    name: `${service.name} - Copie`,
    description: service.description || ''
  });

  const handleSubmit = async () => {
    try {
      setLoading(true);
      setError('');

      await duplicateService(service.id, formData);
      onSuccess();
    } catch (error) {
      console.error('Erreur lors de la duplication:', error);
      setError('Erreur lors de la duplication du service');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content duplicate-service-modal">
        <div className="modal-header">
          <h2>Duplication de service</h2>
          <FaTimes className="close-icon" onClick={onClose} />
        </div>

        <div className="modal-body">
          <div className="form-group">
            <label>Nom de service</label>
            <input
              type="text"
              placeholder="Ex : Transport"
              value={formData.name}
              onChange={(e) => setFormData(prev => ({ ...prev, name: e.target.value }))}
            />
          </div>

          <div className="form-group">
            <label>Description courte</label>
            <textarea
              placeholder="Tapez ici..."
              value={formData.description}
              onChange={(e) => setFormData(prev => ({ ...prev, description: e.target.value }))}
            />
          </div>

          {error && <div className="error-message">{error}</div>}
        </div>

        <div className="modal-footer">
          <button className="btn-secondary" onClick={onClose}>
            Annuler
          </button>
          <button 
            className="btn-primary" 
            onClick={handleSubmit}
            disabled={loading}
          >
            {loading ? 'Duplication...' : 'Dupliquer'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default DuplicateServiceModal;